import { render, staticRenderFns } from "./menu-list-vessel.vue?vue&type=template&id=ff03dd82&scoped=true"
import script from "./menu-list-vessel.vue?vue&type=script&lang=js"
export * from "./menu-list-vessel.vue?vue&type=script&lang=js"
import style0 from "./menu-list-vessel.vue?vue&type=style&index=0&id=ff03dd82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff03dd82",
  null
  
)

export default component.exports